import React from 'react';

export const FormContent: React.FC<{
  children: React.ReactNode;
}> = (props) => {
  return (
    <div
      className={
        '' +
        'rounded-[20px] ' +
        'bg-[--c-background2] ' +
        'min-h-[250px] ' +
        'p-[15px] ' +
        'flex ' +
        'flex-col ' +
        'gap-[30px]'
      }
    >
      {props.children}
    </div>
  );
};
